import { ELIGIBILITY_CHECK_TYPES } from "constants/eligibilityCheckTypes";

function eligibilityCheckTypeToLabel(code) {
  return ELIGIBILITY_CHECK_TYPES[code];
}

export { eligibilityCheckTypeToLabel };
